export const MAINNET_ADDRESS = {
  BUSD: '',
  BBET: '',
  XBT: '',
  STAKING: ''
};
